<template>
	<el-container id="app">
		<el-container style="height: 98vh;margin-bottom: -20px;">
			<el-header style="height: 80px;text-align: right; font-size: 12px;">
				<div class="left">
					<h1>
						<a :href="$store.state.ROOT_URL" target="_blank">
							中链企通
						</a>
					</h1>
					<h2>
						<span>工作台</span>
						<a :href="$store.state.USER_URL+'/member#/member'" class="switch"><i
								class="el-icon-news" />切换买家</a>
					</h2>
				</div>
				<el-dropdown @command="handleCommand">
					<router-link to="" class="right">
						<div class="user-img">
							<el-image :src="$store.state.IMG_URL+$store.state.HEAD_IMG">
								<img src="@/assets/img/user.png" slot="error" class="user-error-img">
							</el-image>
						</div>
						<div class="user-num">{{$store.state.USER_NAME}}<i class="el-icon-arrow-right" /></div>
					</router-link>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="1">基本信息</el-dropdown-item>
						<el-dropdown-item command="3">我的店铺</el-dropdown-item>
						<el-dropdown-item command="2">退出登录</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</el-header>
			<el-container class="appCount">
				<el-aside width="240px" scrolling="no" style="height: 89vh;background-color: rgb(238, 241, 246);z-index: 999;">
					<el-menu unique-opened router open :default-openeds="openeds">
						<el-menu-item index="/">
							<i class="el-icon-monitor"></i>
							<span>概况</span>
						</el-menu-item>
						<el-submenu index="2">
							<template slot="title">
								<i class="el-icon-s-shop"></i>
								<span slot="title">店铺管理</span>
							</template>
							<el-menu-item index="/renovation">店铺装修</el-menu-item>
							<el-menu-item index="/ShopTemplate" v-if="Number(flagship) != 1">定制店铺</el-menu-item>
							<el-menu-item index="/bdxcx">百度小程序</el-menu-item>
							<el-menu-item index="/applet">微信小程序</el-menu-item>
							<el-menu-item index="/cusCl">店铺产品分类</el-menu-item>
							<el-menu-item index="/setShop">店铺设置</el-menu-item>
							<el-menu-item index="/album">相册管理</el-menu-item>
							<!-- v-if="this.$store.state.USER_ID == 16" -->
							<el-menu-item index="/VideoAlbum" v-if="this.$store.state.USER_ID == 16">视频相册管理</el-menu-item>
							<el-menu-item index="/Auszahlung">在线交易</el-menu-item>
						</el-submenu>
						<!-- <el-submenu index="5">
							<template slot="title">
								<i class="el-icon-reading"></i>
								<span slot="title">专家管理</span>
							</template>
							<el-menu-item index="/expert">专家信息</el-menu-item>
							<el-menu-item index="/expertList">专家文库</el-menu-item>
						</el-submenu> -->
						<!-- <el-submenu index="6">
							<template slot="title">
								<i class="el-icon-reading"></i>
								<span slot="title">展会管理</span>
							</template>
							<el-menu-item index="/expo">展会设置</el-menu-item>
							<el-menu-item index="/zhnews">展会管理</el-menu-item>
						</el-submenu> -->
						<!-- <el-menu-item index="/zhnews">
							<i class="el-icon-chat-dot-square"></i>
							<span>展会新闻</span>
						</el-menu-item> -->
						<el-submenu index="3">
							<template slot="title">
								<i class="el-icon-document"></i>
								<span slot="title">信息管理</span>
							</template>
							<el-menu-item index="/product">产品管理</el-menu-item>
							<el-menu-item index="/purchase">采购管理</el-menu-item>
							<el-menu-item index="/video" v-if="this.$store.state.USER_ID == 16">视频管理</el-menu-item>
							<!-- <el-menu-item index="/video">视频管理</el-menu-item> -->
							<el-menu-item index="/cases">工程案例</el-menu-item>
							<el-menu-item index="/company">企业要闻</el-menu-item>
							<el-menu-item index="/honor">荣誉资质</el-menu-item>
							<el-menu-item index="/newest">最新研发</el-menu-item>
							<el-menu-item index="/industry">行业应用</el-menu-item>
							<el-menu-item index="/recruitment">招聘信息</el-menu-item>
							<el-menu-item index="/news">资讯管理</el-menu-item>
						</el-submenu>
						<el-submenu index="9">
							<template slot="title">
								<i class="el-icon-collection"></i>
								<span slot="title">使用教程</span>
							</template>
							<el-menu-item index="/Tutorial">使用教程</el-menu-item>
						</el-submenu>
						<el-submenu index="6" v-if="Number(isz) > 0" >
							<template slot="title">
								<i class="el-icon-s-ticket"></i>
								<span slot="title">投票管理</span>
							</template>
							<el-menu-item index="/vote" >投票管理</el-menu-item>
						</el-submenu>
						<!-- 展会管理 -->
						<el-submenu index="7" v-if="Number(isz) >0">
							<template slot="title">
								<i class="el-icon-reading"></i>
								<span slot="title">展会管理</span>
							</template>
							<el-menu-item index="/zhgl">展会管理</el-menu-item>
							<el-menu-item index="/Zhnews">展会新闻</el-menu-item>
							<el-menu-item index="/Hyzh">行业展会</el-menu-item>
							<el-menu-item index="/Wjhg">往届回顾</el-menu-item>
						</el-submenu>
						<el-submenu index="4">
							<template slot="title">
								<i class="el-icon-user"></i>
								<span slot="title">会员服务</span>
							</template>
							<el-menu-item index="/order">订单管理</el-menu-item>
							<el-menu-item index="/assets">资产管理</el-menu-item>
							<el-menu-item index="/tiktok">D音获客</el-menu-item>
							<el-menu-item index="/integral">积分管理</el-menu-item>
						</el-submenu>
						<el-menu-item index="/announcement">
							<i class="el-icon-chat-dot-square"></i>
							<span>系统公告</span>
						</el-menu-item>
						<el-menu-item index="/LeavingMessage">
							<i class="el-icon-message"></i>
							<span>留言管理</span>
						</el-menu-item>
						<el-submenu index="8" v-if="Number(flagship) == 1 || this.$store.state.USER_ID == 16">
							<template slot="title">
								<i class="el-icon-reading"></i>
								<span slot="title">会员管理</span>
							</template>
							<el-menu-item index="/hymember">会员列表</el-menu-item>
							<el-menu-item index="/expertTeam">专家团队</el-menu-item>
							<el-menu-item index="/hyproduct">产品列表</el-menu-item>
							<el-menu-item index="/hypreferred" >优选厂商</el-menu-item>
							<el-menu-item index="/hynews">新闻列表</el-menu-item>
							<el-menu-item index="/hyprocure">采购列表</el-menu-item>
							<el-menu-item index="/hyposter">广告管理</el-menu-item>
							<el-menu-item index="/hyorder">订单列表</el-menu-item>
							<el-menu-item index="/hylinksList">友情链接</el-menu-item>
						</el-submenu>
						<el-menu-item v-if="this.$store.state.USER_ID == 16" index="/communication">
							<i class="el-icon-s-promotion"></i>
							<span>即时通讯</span>
						</el-menu-item>
					</el-menu>
				</el-aside>
				<el-main style="height: 89vh;background:#f6f5f7;">
					<div style="background-color: #fff;height: 89vh;">
						<router-view />
					</div>
				</el-main>
			</el-container>
		</el-container>
	</el-container>
</template>
<script>
	export default {
		data(){
			return{
				openeds: ['2'],
				isz:this.$store.state.ISZ,
				flagship:this.$store.state.FLAGSHIP,
				// Store.state.I_SHOP
			}
		},
		beforeCreate() {
			this.isz = this.$store.state.ISZ
			this.flagship = this.$store.state.FLAGSHIP
		},
		created() {
			this.isz = this.$store.state.ISZ
			this.flagship = this.$store.state.FLAGSHIP
		},
		methods: {
			handleCommand(command) {
				if (command == 1) {
					this.$router.push('/user')
				}
				if (command == 2) {
					// location.href = this.$store.state.USER_URL+"/Login-login.html"
					window.localStorage.clear()
					//location.href=this.$store.state.USER_URL
					location.href = this.$store.state.USER_URL+"/Login-login.html"
				}
				if (command == 3) {
					location.href = this.$store.state.USER_URL+"/shop-"+this.$store.state.USER_ID+'.html'
				}
			},
		}
	}
</script>
<style>
	#app {
		min-width: 997px;
		width: 100%;
	}
	.appCount{
		width: 100%;
		display: flex;
		justify-content: space-between;
	}
	a {
		text-decoration: none;
	}

	ul li {
		list-style: none;
	}

	.el-header {
		background-color: #0194fe;
		color: #333;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.el-header .left {
		display: flex;
		align-items: center;
	}

	.el-header .left h2 {
		color: #fff;
		font-size: 29px;
		font-weight: 400;
		margin-left: 20px;
	}

	.el-header .left .switch {
		font-size: 14px;
		margin-left: 10px;
		color: #fff;
	}

	.el-header .right {
		display: flex;
		align-items: center;
	}

	.user-img {
		width: 46px;
		height: 46px;
		border-radius: 50%;
		overflow: hidden;
		background: #fff;
	}

	.user-error-img {
		width: 46px;
		height: 46px;
	}

	.user-num {
		color: #fff;
		margin-left: 16px;
		font-size: 18px;
	}

	.user-num i {
		margin-right: 17px;
	}

	.el-aside {
		color: #333;
	}

	/* 纵向滚动条 */
	.el-aside::-webkit-scrollbar {
		display: none;
	}

	.el-page-header {
		padding: 20px;
	}

	.add-btn {
		margin: 10px 0 20px 20px;
	}

	.el-table {
		width: 1567px;
		margin: 10px auto;
	}

	.o-wrap,
	.wrap {
		width: 1600px;
		background-color: #fff;
	}

	.purForm {
		width: 792px;
		margin-left: 20px;
	}

	.left h1 a{
		text-decoration: none;
		width: 126px;
		height: 46px;
		font-size: 26px;
		color: #00DD63;
		line-height: 46px;
		text-align: center;
	}
	
	
</style>
